import { constants } from "../attributes/EquipmentCalculatedAlerts.js";
import CalculatedAlertsEqualsComparator from "./EquipmentCalculatedAlertsEqualsComparator.js";
import AliasEqualsSelector from "../../../attributes/filters/AliasEqualsSelector.js";
const options = () => [{
  name: 'Theft Recovery Activated',
  value: constants.THEFT_RECOVERY_ACTIVATED
}, {
  name: 'Theft Recovery Activating',
  value: constants.THEFT_RECOVERY_ACTIVATING
}, {
  name: 'Theft Recovery Ending',
  value: constants.THEFT_RECOVERY_ENDING
}, {
  name: 'Position Pending',
  value: constants.POSITION_PENDING
}, {
  name: 'Pending Automatic Location Transfer',
  value: constants.PENDING_AUTOMATIC_LOCATION_TRANSFER
}, {
  name: 'Device Health Problem',
  value: constants.DEVICE_HEALTH
}, {
  name: 'End of Life',
  value: constants.END_OF_LIFE
}, {
  name: 'Not Reporting',
  value: constants.NOT_REPORTING
}, {
  name: 'Not Operational',
  value: constants.NON_OPERATIONAL
}, {
  name: 'Not Activated',
  value: constants.NOT_ACTIVATED
}].sort((a, b) => a.name.localeCompare(b.name));
export default AliasEqualsSelector.create(CalculatedAlertsEqualsComparator, options);